import * as types from "./mutation-types";

export default {
  [types.SET_tipos_instrumentoS](state, payload) {
    state.tipos_instrumentos = payload;
  },
  [types.SET_tipo_instrumento](state, payload) {
    state.tipo_instrumento = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
